exports.filterClosed =  (records, showClosed) => records.filter(r => showClosed ? r : !r.closed)